import React, { useEffect, useRef, useState } from 'react'
import {
  showErrMessage,
  showSuccessMessage,
} from '../components/utils/notification/Notification'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBackward,
  faEdit,
  faEye,
  faForward,
  faTrashAlt,
  faWallet,
} from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import LoadingBox from '../components/LoadingBox'
import { Link, useHistory } from 'react-router-dom'
import './ProfileScreen.css'
import { Box, Button, Card, CardActions, CardContent, TextField, Typography } from '@mui/material'
import BottomNavBar from '../components/BottomNavBar'

const initialState = {
  name: '',
  lastName: '',
  password: '',
  cf_password: '',
  err: '',
  success: '',
}


const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);


export default function ProfileScreen(props) {

  var   _ProWallet                   = localStorage.getItem('_ProWallet')
  const userID                       = localStorage.getItem('userID')
  const role                         = Number(localStorage.getItem('role'))
  const Logged                       = localStorage.getItem('userStatus')

  const nom           = localStorage.getItem('nom')
  const prenoms       = localStorage.getItem('prenoms')
  const email         = localStorage.getItem('email')
  const countryname   = localStorage.getItem('countryname')
  const city          = localStorage.getItem('city')
  const country       = localStorage.getItem('country')
  const borningWay    = localStorage.getItem('borningWay')
  const phone         = localStorage.getItem('phone')
  const integrate     = localStorage.getItem('integrate')

  const [data,                         setData                ] = useState(initialState)
  const [GetUser,                      setGetUser             ] = useState([])
  const [User,                         setUser                ] = useState([])
  const [UserStopReq,                  setUserStopReq         ] = useState(false)
  const [avatar,                       setAvatar              ] = useState(false)
  const [loading,                      setLoading             ] = useState(false)
  const [pannel,                       setPannel              ] = useState(false)
  const [SponsorLeaders,               setSponsorLeaders      ] = useState()
  const [showWaveText,                 setShowWaveText        ] = useState(false)
  const [Parrained,                    setParrained           ] = useState()
  const [NkabSearch,                   setNkabSearch          ] =  useState('')
  const [NkabSearchResult,             setNkabSearchResult    ] =  useState()
  const [copyText,                     setCopyText            ] = useState(false)
  const [isCopied,                     setIsCopied            ] = useState(false)
  const [FileSuccess,                  setFileSuccess         ] = useState(false)
  const [FileSize,                     setFileSize            ] = useState(false)
  const [FileFormat,                   setFileFormat          ] = useState(false)
  const history                                                 = useHistory()

  const [NkabSpinner,  setNkabSpinner] = useState(false)
  const [ErrorMessage, setErrorMessage ] = useState("")

  const LineLink = true

  const STATUS = { STARTED: 'Traitement en cours...', }
  
    const INITIAL_COUNT1 = 300
  
    const [secondsRemaining1,            setSecondsRemaining1 ] = useState(INITIAL_COUNT1)
    const [status1,                      setStatus1           ] = useState(STATUS.STOPPED)
  
    useEffect(()=>{
      setStatus1(STATUS.STARTED)
    },[STATUS.STARTED])

  useInterval(
    () => {
    if (secondsRemaining1 > 0) {
        setSecondsRemaining1(secondsRemaining1 - 1)
    } else {
        setStatus1(STATUS.STOPPED)
    }
    },

    status1 === STATUS.STARTED ? 1000 : null,
    // passing null stops the interval
)

function useInterval(callback, delay) {
    const savedCallback = useRef()

    // Remember the latest callback.
    useEffect(() => {
    savedCallback.current = callback
    }, [callback])

// Set up the interval.
useEffect(() => {
  function tick() {
    savedCallback.current()
  }
  if (delay !== null) {
    let id = setInterval(tick, delay)
    return () => clearInterval(id)
  }
}, [delay])
}

var [themeMode, setThemeMode] = useState()

let ThemeMode = localStorage.getItem("ThemeMode")

useEffect(()=>{
  
  if(secondsRemaining1 > 0){
    setThemeMode(ThemeMode)
  }

},[ThemeMode, secondsRemaining1])


  if (_ProWallet === 'true') {
    window.location.replace("https://nkab-exchange.net/nkab-pro");
  }

  useEffect(()=>{
    if(Logged === 'Logout'){
      window.location.replace("https://nkab-exchange.net/login");
    }
  },[Logged, props.history])



  useEffect(()=>{

    const fetchDada12 = async () => {
      try {
        if(!UserStopReq){
          const { data } = await axios.get(
            '/api/v1/get-users',
          )
          if(data.length > 0){
            setGetUser(data)
            setUserStopReq(true)
          }
        }
      } catch (error) {}
    }
    fetchDada12()

  },[UserStopReq])

  useEffect(()=>{

    if(GetUser.length > 0 && userID.length > 0){
      const userGetted = GetUser.filter((obj) => {
        return obj.ID === Number(userID)
      })
      if(userGetted.length > 0){
        setUser(userGetted[0])
  
        localStorage.setItem('nom',           userGetted[0].name)
        localStorage.setItem('prenoms',       userGetted[0].lastName)
        localStorage.setItem('email',         userGetted[0].email)
        localStorage.setItem('countryname',   userGetted[0].countryName)
        localStorage.setItem('city',          userGetted[0].city)
        localStorage.setItem('country',       userGetted[0].country)
        localStorage.setItem('borningWay',    userGetted[0].borningWay)
        localStorage.setItem('phone',         userGetted[0].telNumber)
        localStorage.setItem('integrate',     userGetted[0].createdAt)
      }
    }

  },[GetUser, userID, User])


  const handleChange = (e) => {
    const { name, value } = e.target
    setData({ ...data, [name]: value, err: '', success: '' })
  }

  const handleSearchChange = (e) => {
    const {value} = e.target
    if(GetUser && value){
      const SearchUser = GetUser.filter((obj)=>{
        return obj.name.includes(value)
      })

      setNkabSearchResult(SearchUser)
    }
  }

  const handleSearchChange2 = (e) => {
    const {value} = e.target
    if(GetUser && value){
      const SearchUser = GetUser.filter((obj)=>{
        return obj.email.includes(value)
      })

      setNkabSearchResult(SearchUser)
    }

  }

  const handleSearchChange3 = (e) => {
    const {value} = e.target
    if(GetUser && value){
      const SearchUser = GetUser.filter((obj)=>{
        return obj.telNumber.includes(value)
      })

      setNkabSearchResult(SearchUser)
    }

  }

  useEffect(()=>{
    if(NkabSearchResult){
      setNkabSearch(NkabSearchResult)
      if(NkabSearch){

      }
    }
  },[NkabSearchResult, NkabSearch])


  const notifHandler = async (id) =>{

    const SearchUser = GetUser.filter((obj)=>{
      return obj.ID === id
    })

    if(SearchUser){
      if(SearchUser[0]){
        if(SearchUser[0].role === 1){
          alert(`Vous ne pouvez pas supprimer l'administrateur ${id}!`)
        } else {
          alert(`Veuillez confirmer la suppression de l'utilisateur ${id}!`)
          axios.post(`/api/v1/delete-users`,
            {
              ID: id,
            },
          ).then((response)=>{
            if(response.data.msg === "success"){
              setUserStopReq(false)
              setUserStopReq(false)
            }
          })
        }
      }
    }
  }

  const [TelNumber, setTelNumber] = useState("")
  const [City, setCity] = useState("")

  function redirectToPortefeuille() {
    props.history.push('/nkab-wallet')
  }

  const HandleChange = (event) => {
    setNkabSpinner(false)
    setTelNumber(event.target.value)
    console.log(event.target.value)
    event.preventDefault()
  }

  const HandleChange2 = (event) => {
    setNkabSpinner(false)
    setCity(event.target.value)
    console.log(event.target.value)
    event.preventDefault()
  }

  const handleSubmit = async (event) => {

    setNkabSpinner(true)
    event.preventDefault()

    if((TelNumber || City) && Number(userID)){

      try {
        const res = await axios.post('/api/v1/update-user', {
          ID: Number(userID),
          telNumber: TelNumber,
          city: City,
        })
  
        if (res.data.msg === "success") {
  
          if(LineLink){
            window.location.replace("https://nkab-exchange.net/profile");
          } else {
             window.location.replace("http://localhost:3000/profile");
          }
  
        }
      } catch (err) {

        setErrorMessage("Quelque s'est mal passée!")
        
       }

    }
  }

  return (
      <div className="color-w container">
        <div className='mt-4'>
          <div className='mb-2'><h1>Mon profil</h1></div>
          <div className='nkab-profil-menus'>
            <span className='nkab-profil-menu-item'>Biographie</span>
            <span className='nkab-profil-menu-item'>***?</span>
            <span className='nkab-profil-menu-item'>***?</span>
            <span className='nkab-profil-menu-item'>***?</span>
          </div>
        </div>

        <div className='row mt-3'>
            <div className='col-md-3'></div>
            <div className='col-md-6'>
              <Card variant="outlined" style={{color: `${themeMode === "true" ? "#bae7ff" : ""}`, backgroundColor:`${themeMode === "true" ? "#0E233A" : ""}`}}>
                <CardContent>
                  <div className='nkab-profil-content-item mb-4'>
                    <Typography variant="h5" component="div"> Informations personelles </Typography>
                    <Typography sx={{ mb: 1.5, color: `${themeMode === "true" ? "#bae7ff" : ""}` }} color="text.secondary"> Personnalisez la façon dont les informations de votre profil apparaîtront sur cette plateforme. </Typography>
                  </div>
                  <div className='row nkab-profil-content-item'>
                    <div className='col-md-3'><img src="../../images/nkab-avatar.png" alt="nkab avatar" width="100" height="95" /></div>
                    <div className='col-md-9'>
                      <Box
                        component="form"
                        sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' }}}
                        noValidate
                        autoComplete="off"
                      >
                        <div>
                          <TextField label="Nom" id="filled-size-small" sx={{ color: `${themeMode === "true" ? "#bae7ff" : ""}` }} defaultValue={nom} variant="filled" size="small" disabled />
                          <TextField label="Prénoms" id="filled-size-small" sx={{ color: `${themeMode === "true" ? "#bae7ff" : ""}` }} defaultValue={prenoms} variant="filled" size="small" disabled/>
                        </div>
                        <div>
                          <TextField label="E-Mail" id="filled-size-small" sx={{ color: `${themeMode === "true" ? "#bae7ff" : ""}` }} defaultValue={email} variant="filled" size="small" disabled />
                          <TextField label="Pays" id="filled-size-small" sx={{ color: `${themeMode === "true" ? "#bae7ff" : ""}` }} defaultValue={countryname} variant="filled" size="small" disabled />
                        </div>
                        <div>
                          <TextField label="Adresse" id="filled-size-small" sx={{ color: `${themeMode === "true" ? "#bae7ff" : ""}` }} defaultValue={`${city},${countryname}`} variant="filled" size="small" disabled />
                          <TextField label="Téléphone" id="filled-size-small" sx={{ color: `${themeMode === "true" ? "#bae7ff" : ""}` }} defaultValue={phone} variant="filled" size="small" onChange={HandleChange} disabled/>
                        </div>
                        <div>
                          <TextField label="Lieu de naissance" id="filled-size-small" sx={{ color: `${themeMode === "true" ? "#bae7ff" : ""}` }} defaultValue={borningWay} variant="filled" size="small" disabled />
                          <TextField label="Lieu de résidence" id="filled-size-small" sx={{ color: `${themeMode === "true" ? "#bae7ff" : ""}` }} defaultValue={city} variant="filled" size="small" onChange={HandleChange2} disabled/>
                        </div>
                      </Box>
                    </div>
                  </div>
                </CardContent>
                <CardActions sx={{float:"right"}}>
                  <Button variant="outlined" size="small"> Annuler </Button>
                  <Button variant="contained" size="small"> { !NkabSpinner?"Enregistrer":<div className="nkab-spinner"></div> } </Button>
                  {/* <Button variant="contained" size="small" onClick={handleSubmit}> { !NkabSpinner?"Enregistrer":<div className="nkab-spinner"></div> } </Button> */}
                </CardActions>
              </Card>
            </div>
            <div className='col-md-3'></div>
          </div>
      <BottomNavBar />
    </div>
  )
}
